import type { FormType } from "../../../core/store/currentFormSlice";

/**
 * The flags a submitted form sets on the practice patient. An admission form puts the patient on the reception's
 * admissions list, an anamnesis on that list and in the therapy waiting room; each list's open flag is set in the same
 * write, so a patient ticked off there is back on the list with the new form (EMP-53).
 */
export const formFlagChanges = (
  formType: FormType | undefined,
): Record<string, true> => {
  const changes: Record<string, true> = { "flags.hasFormSubmission": true };
  if (formType === "onboarding") {
    changes["flags.onboardingCompleted"] = true;
    changes["flags.firstAdmissionCompleted"] = true;
    changes["flags.admissionOpen"] = true;
  }
  if (formType === "anamnesis") {
    changes["flags.onboardingCompleted"] = true;
    changes["flags.firstAnamnesisCompleted"] = true;
    changes["flags.admissionOpen"] = true;
    changes["flags.waitingRoomOpen"] = true;
  }
  return changes;
};
